import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "bg-white p-3 mb-4" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-lg-6 col-12" };
const _hoisted_4 = { class: "form-floating mb-3" };
const _hoisted_5 = { class: "form-floating mb-3" };
const _hoisted_6 = { class: "form-floating mb-3" };
const _hoisted_7 = { class: "form-floating mb-3" };
const _hoisted_8 = ["value"];
const _hoisted_9 = { class: "col-lg-6 col-12" };
const _hoisted_10 = { class: "form-floating mb-3" };
const _hoisted_11 = { class: "form-floating mb-3" };
const _hoisted_12 = { class: "form-floating mb-3" };
const _hoisted_13 = {
    key: 0,
    class: "fw-bold text-danger"
};
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, useForm } from '@inertiajs/vue3';
import { onMounted } from 'vue';
import { responseMessages } from '@/Composables/responseMessages';
import { useConfirm } from 'primevue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        user: Object,
        languages: Object
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        const props = __props;
        const confirm = useConfirm();
        const editUserForm = useForm({
            firstname: props.user ? props.user.firstname : null,
            lastname: props.user ? props.user.lastname : null,
            email: props.user ? props.user.email : null,
            lang: props.user ? props.user.lang : 'de'
        });
        const editPasswordForm = useForm({
            oldPassword: null,
            password: null,
            confirmPassword: null
        });
        onMounted(() => {
        });
        function updateUser() {
            editUserForm.transform((data) => ({
                firstname: data.firstname,
                lastname: data.lastname,
                email: data.email,
                lang: data.lang
            })).submit('put', route('admin.myProfile.update'), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function updatePassword() {
            editPasswordForm.transform((data) => ({
                old_password: data.oldPassword,
                password: data.password,
            })).submit('put', route('admin.myProfile.updatePassword'), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Mein Profil" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _cache[17] || (_cache[17] = _createElementVNode("h1", { class: "fw-bold mb-3" }, "Mein Profil", -1)),
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("form", {
                                        onSubmit: _withModifiers(updateUser, ["prevent"])
                                    }, [
                                        _createElementVNode("div", _hoisted_4, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "firstname",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(editUserForm).firstname) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(editUserForm).firstname]
                                            ]),
                                            _cache[7] || (_cache[7] = _createElementVNode("label", { for: "firstname" }, "Vorname", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_5, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "lastname",
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(editUserForm).lastname) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(editUserForm).lastname]
                                            ]),
                                            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "lastname" }, "Nachname", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_6, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "email",
                                                class: "form-control",
                                                id: "email",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(editUserForm).email) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(editUserForm).email]
                                            ]),
                                            _cache[9] || (_cache[9] = _createElementVNode("label", { for: "email" }, "E-Mail", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_7, [
                                            _withDirectives(_createElementVNode("select", {
                                                class: "form-select",
                                                id: "lang",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(editUserForm).lang) = $event)),
                                                required: ""
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.languages, (language) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        value: language.code
                                                    }, _toDisplayString(language.name), 9, _hoisted_8));
                                                }), 256))
                                            ], 512), [
                                                [_vModelSelect, _unref(editUserForm).lang]
                                            ]),
                                            _cache[10] || (_cache[10] = _createElementVNode("label", { for: "lang" }, "Sprache", -1))
                                        ]),
                                        _cache[11] || (_cache[11] = _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ], -1))
                                    ], 32)
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                    _cache[16] || (_cache[16] = _createElementVNode("h5", { class: "fw-bold text-primary mb-3" }, "Neue Zugangsdaten erstellen", -1)),
                                    _createElementVNode("form", {
                                        onSubmit: _withModifiers(updatePassword, ["prevent"])
                                    }, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "password",
                                                class: "form-control",
                                                id: "oldPassword",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(editPasswordForm).oldPassword) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(editPasswordForm).oldPassword]
                                            ]),
                                            _cache[12] || (_cache[12] = _createElementVNode("label", { for: "oldPassword" }, "Altes Passwort", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_11, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "password",
                                                class: "form-control",
                                                id: "password",
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(editPasswordForm).password) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(editPasswordForm).password]
                                            ]),
                                            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "password" }, "Passwort", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_12, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "password",
                                                class: "form-control",
                                                id: "confirmPassword",
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(editPasswordForm).confirmPassword) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(editPasswordForm).confirmPassword]
                                            ]),
                                            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "confirmPassword" }, "Passwort wiederholen", -1))
                                        ]),
                                        (_unref(editPasswordForm).password != _unref(editPasswordForm).confirmPassword)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Die Passwörter stimmen nicht überein."))
                                            : _createCommentVNode("", true),
                                        _cache[15] || (_cache[15] = _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ], -1))
                                    ], 32)
                                ])
                            ])
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
